<template>
  <div>
    <div style="text-align:right;background-color:lawngreen;margin:5px auto;border-radius:3px;padding:5px;">
      {{query}}
    </div>
    <div style="text-align:left;background-color:deepskyblue;margin:5px auto;border-radius:3px;padding:5px;">
      {{response}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    query: String,
    response: String,
  },
};
</script>
